import {
  IonAvatar,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonList,
  IonListHeader,
  IonNote,
  IonPage,
  IonRow,
  IonTitle,
  IonToolbar,
  useIonToast,
} from "@ionic/react";
import { cartOutline, reloadOutline } from "ionicons/icons";
import { useEffect, useState } from "react";
import useSound from "use-sound";
import client from "utils/Api";
import closeSound from "../sounds/close.wav";
import { fiatFormat } from "../utils/Currency";

export const QRCodeScannedModal = ({ dismiss, code, scan, scanner_key }) => {
  const [play] = useSound(closeSound);
  const [showToast] = useIonToast();
  const [loading, setLoading] = useState(false);
  const [purchases, setPurchases] = useState([]);
  const axiosClient = client();

  const onProcessQRCode = async (code) => {
    setLoading(true);
    const verified = await axiosClient.post("/scanner/payments", {
      id: code.code,
      invoice_id: code.invoice_id,
      multi: code.multi,
      scanner_key: scanner_key,
    });
    setLoading(false);
    if (verified.data.success) {
      showToast({
        header: "Successfully verified!",
        message: "Invoice verified successfully.",
        duration: 3000,
        color: "success",
      });
      if (verified.data.purchases?.length > 0) {
        setPurchases(verified.data.purchases);
      }
    } else {
      showToast({
        header: "Error!",
        message: verified.data.error,
        duration: 3000,
        color: "danger",
      });
    }
  };

  const handleDismiss = () => {
    dismiss();
    play();
  };

  const handleScanAgain = () => {
    handleDismiss();

    setTimeout(() => {
      scan();
    }, 10);
  };

  // const handleAdd = async () => {
  //   setCodes((codes) => {
  //     return [...codes, code];
  //   });
  //   showToast({
  //     header: "Success!",
  //     message: "QR Code stored successfully.",
  //     duration: 3000,
  //     color: "primary",
  //   });

  //   handleDismiss();
  // };

  useEffect(() => {
    if (code) onProcessQRCode(JSON.parse(code));
  }, []);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>View QR Code</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={handleDismiss}>Close</IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <IonGrid className="ion-padding-top ion-margin-top">
          {/* <IonRow className="ion-justify-content-center ion-text-center animate__animated animate__lightSpeedInLeft animate__faster">
            <IonCol size="12">
              <QRCode value={code.text ? code.text : code} />
            </IonCol>
          </IonRow> */}

          <IonRow>
            <IonCol size="12">
              <IonCard>
                <IonCardHeader>
                  <IonCardTitle>Voucher Scan</IonCardTitle>
                  <IonNote>This is what the code represents</IonNote>
                </IonCardHeader>
                <IonCardContent>
                  <IonToolbar>
                    {loading ? (
                      <h1>Loading...</h1>
                    ) : (
                      <IonButton
                        color="success"
                        expand="block"
                        onClick={() => dismiss()}
                      >
                        Confirm
                      </IonButton>
                    )}
                  </IonToolbar>
                  <IonList lines="none">
                    <IonListHeader>Items</IonListHeader>
                    {purchases.length > 0 &&
                      purchases
                        .reduce((arr, x) => {
                          const title =
                            x?.description ||
                            x?.promotion?.product.title ||
                            x?.product?.title;
                          const total = purchases.filter(
                            (y) =>
                              (y?.description ||
                                y?.promotion?.product.title ||
                                y?.product?.title) === title
                          ).length;
                          const cost = purchases.reduce(
                            (sum, y) =>
                              (y?.description ||
                                y?.promotion?.product.title ||
                                y?.product?.title) === title
                                ? parseFloat(sum) + parseFloat(y.amount)
                                : sum,
                            0
                          );
                          const found = arr.filter(
                            (y) =>
                              (y?.description ||
                                y?.promotion?.product.title ||
                                y?.product?.title) === title
                          ).length;
                          if (found === 0) {
                            arr.push({ ...x, qty: total, totalCost: cost });
                          }
                          return arr;
                        }, [])
                        .map((x, i) => {
                          return (
                            <IonItem key={x.id + i}>
                              <IonAvatar slot={"start"}>
                                {x.product?.media_url ||
                                x.promotion?.product?.media_url ? (
                                  <img
                                    alt={x.product?.title}
                                    src={
                                      x.product?.media_url ||
                                      x.promotion?.product?.media_url
                                    }
                                  />
                                ) : (
                                  <IonIcon
                                    icon={cartOutline}
                                    size={"large"}
                                    style={{ width: "100%", height: "100%" }}
                                  />
                                )}
                              </IonAvatar>
                              {x?.description ||
                                x?.promotion?.product.title ||
                                x?.product?.title}
                              {x.qty > 1 && <small> &nbsp; x {x.qty}</small>}
                              <IonNote slot="end">
                                {fiatFormat(x.totalCost)}
                              </IonNote>
                            </IonItem>
                          );
                        })}
                  </IonList>
                </IonCardContent>
              </IonCard>
            </IonCol>
          </IonRow>

          <IonRow>
            <IonCol size="1"></IonCol>
            <IonCol size="10">
              <IonButton
                expand="block"
                fill="outline"
                onClick={handleScanAgain}
              >
                <IonIcon icon={reloadOutline} />
                &nbsp; Scan again
              </IonButton>
            </IonCol>
            <IonCol size="1"></IonCol>
            {/* <IonCol size="6">
              <IonButton expand="block" onClick={handleAdd}>
                Store &rarr;
              </IonButton>
            </IonCol> */}
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};
